'use strict';

module.exports = function(Chart) {

	Chart.Line = function(context, config) {
		config.type = 'line';

		return new Chart(context, config);
	};

};



//////////////////
// WEBPACK FOOTER
// ./node_modules/chart.js/src/charts/Chart.Line.js
// module id = 673
// module chunks = 170